// libs
import React, { memo } from 'react';
import { styled } from '@nykaa/ui-components';

// helpers
import { COLORS, BREAKPOINTS, BASE_GUTTER_SPACE } from 'shared/styles/base';

export const Container = styled.div<{ isFloatingTags: boolean }>`
  ${({ isFloatingTags }) =>
    isFloatingTags === true &&
    `position: absolute;  bottom: ${BASE_GUTTER_SPACE}px; left: ${BASE_GUTTER_SPACE}px; `};
`;

const Tag = styled.span<{
  borderColor: string;
  bgColor: string;
  titleColor: string;
  transparency_web: number;
}>`
  ${({ borderColor }) => `border: 1px solid ${borderColor}`};
  ${({ transparency_web }) => `opacity: ${transparency_web}`};
  ${({ bgColor }) => `background: ${bgColor}`};
  color: ${({ titleColor }) => (titleColor ? titleColor : COLORS.BLACK_92)};

  border-radius: 2px;
  display: inline-block;
  padding: ${BASE_GUTTER_SPACE / 4}px ${BASE_GUTTER_SPACE / 2}px;
  margin: 0px ${BASE_GUTTER_SPACE}px ${BASE_GUTTER_SPACE}px 0px;
  height: 16px;

  .tag-title {
    margin: 0;
    ${({ theme }) => theme.typography.labelSmall}
    display: block;
  }

  @media screen and (max-width: 370px) {
    &:nth-child(n + 2) {
      display: none;
    }
  }

  &:nth-last-child(1) {
    margin-right: 0px;
  }

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    height: 20px;
    .tag-title {
      ${({ theme }) => theme.typography.subTitleSmall};
    }
  }
`;

interface IMultiTagsProps {
  tagData?: Listing.IProductTag[];
  isFloatingTags?: boolean;
  dataTest?: string;
}

function MultiTags({ dataTest, tagData, isFloatingTags = false }: IMultiTagsProps) {
  if (tagData === undefined || Array.isArray(tagData) === false) {
    return null;
  }

  return (
    <Container data-test={dataTest} isFloatingTags={isFloatingTags}>
      {tagData.map((item: Listing.IProductTag, idx: number) => {
        const { title, titleColor, bgColor, borderColor, transparency_web } = item;
        return (
          <Tag
            data-test="product-tag"
            key={idx}
            titleColor={titleColor}
            bgColor={bgColor}
            borderColor={borderColor}
            transparency_web={transparency_web}
          >
            <span className="tag-title">{title}</span>
          </Tag>
        );
      })}
    </Container>
  );
}

export default memo(MultiTags);
